module.exports = __webpack_public_path__ + "static/CircularStd-Book-cba4f4f1eed3fceaeeebf29acf2a0ad6.woff";